<template>
  <div id="dataExport">
    <div class="header">
      <el-row style="height: 40px; line-height: 40px">
        <el-col :span="14">
          <span style="font-size: 16px; font-weight: bold; margin-right: 10px">月份</span>
          <!--                    <el-date-picker-->
          <!--                            v-model="date"-->
          <!--                            style="width: 150px"-->
          <!--                            format="yyyy年MM月"-->
          <!--                            value-format="yyyy-MM"-->
          <!--                            type="month"-->
          <!--                            placeholder="选择月">-->
          <!--                    </el-date-picker>-->
          <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="buttonArr">
        <el-button :key="index" v-for="(item, index) in showArr" @click="downloadDetail(item)"
          style="margin-top: 20px; margin-left: 0; margin-right: 15px" type="primary" size="small"
          icon="el-icon-download">
          {{ item.button }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import http from "../../../APIService/http";
  import moment from "moment";
  import popedom from "./popedom";
  import reportMonth from "./reportMonthCopy";

  export default {
    name: "dataExport",
    data() {
      let that = this;
      return {
        date: "",
        month: "",
        endmonth: "",
        isManager: this.$store.getters.getUser.role !== "staff",
        showArr: []
      };
    },
    components: {
      popedom,
      reportMonth,
    },
    created() {
      this.yearsDate = moment(this.GLOBAL.date).format("YYYY年MM月");
      this.init();
      debugger
    },
    methods: {
      async init() {
        debugger
        const loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
          }
          await http.post('/crm/web/report/sfe/getReportSfeList', data).then(res => {
            if (res.success) {
              this.showArr = res.data;

              loading.close()
            }
          })
        } catch (e) {
          console.log(e);
          loading.close()
        }
      },
      async downloadDetail(item) {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let user = this.$store.getters.getUser;
        let params = {};
        params.tenant_id = user.tenant_id;
        // if (this.GLOBAL.date) {
        //   debugger
        //   params.month = moment().format("YYYY-MM");
        // } else {
        //   params.month = "";
        // }
        debugger;
        item.month = this.month ? this.month : moment().format("YYYYMM");
        item.endmonth = this.endmonth ? this.endmonth : moment().format("YYYYMM");
        debugger
        await axios({
          method: "post",
          url: "/wapi/derive/exportReportSfe",
          data: item,
          responseType: 'arraybuffer'
          // responseType: "blob",
        })
          .then((res) => {
            // let uInt8Array = new Uint8Array(res.data); //先将返回的二进制数组转化为js的二进制数组
            // if (res.status !== 200) {
            //   loading.close();
            //   this.$message.error("下载失败");
            //   return;
            // }
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
              //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
            }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
            const elink = document.createElement("a");
            elink.download = item.button+".xlsx";
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
            loading.close();
          })
          .catch((e) => {
            loading.close();
            this.$message.error("下载失败");
          });
      },

      handleSelectInputClick() {
        // this.getData();
      },
      shelfData() {
        // this.getData();
      },
      handleSelectInput(date) {
        // this.date = j;
        this.month = moment(date[0]).format('YYYY-MM')
        this.endmonth = moment(date[1]).format('YYYY-MM')
      },
    },
  };
</script>

<style scoped>
  .header {
    border-bottom: 2px dotted rgb(231, 234, 236);
    padding-bottom: 20px;
  }

  .el-form {
    padding-bottom: 20px;
  }

  .el-form-item {
    margin-bottom: 0;
  }
</style>


// WEBPACK FOOTER //
// src/pages/statement/components/SfeExport.vue